import { render } from "./WritingAbstractDialog.vue?vue&type=template&id=5cfb917c&scoped=true"
import script from "./WritingAbstractDialog.vue?vue&type=script&lang=js"
export * from "./WritingAbstractDialog.vue?vue&type=script&lang=js"

import "./WritingAbstractDialog.vue?vue&type=style&index=0&id=5cfb917c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfb917c"]])

export default __exports__